import { takeLatest, put, call } from 'redux-saga/effects';
import { CORE_API, RATING_SEARCH } from '../../../config';
import request from '../../../../src/components/Utils/httpHelper';
import { HTTP_HEADERS } from '../../../../src/constants';
import * as RatingCompanyMapActions from './action'

export function* fetchMappedCompanyName(action) {
    let requestURL = `${CORE_API}/ratingservices/getMappedCompany/${action.id}`;
    try {
        const result = yield call(request, requestURL, { method: 'GET', headers: HTTP_HEADERS });
        yield put(RatingCompanyMapActions.responseMappedCompanyName(result.data));
    } catch (err) {
        yield put(RatingCompanyMapActions.responseMappedCompanyName(err.response))
    }
}

export function* fetchMappedCompanyNameData() {
    yield takeLatest(RatingCompanyMapActions.REQUEST_FOR_MAPPED_COMPANYNAME, fetchMappedCompanyName);
}

export function* fetchCompanyNameList(action) {
    let requestURL = `${RATING_SEARCH}/searchservices/getagencynames`;
    try {
        const result = yield call(request, requestURL, { data: action.data, method: 'POST', headers: HTTP_HEADERS });
        yield put(RatingCompanyMapActions.responseCompanyNameSearch(result.data));
    } catch (err) {
        yield put(RatingCompanyMapActions.responseCompanyNameSearch(err.response))
    }
}

export function* fetchCompanyNameListData() {
    yield takeLatest(RatingCompanyMapActions.REQUEST_FOR_COMPANYNAME_SEARCH, fetchCompanyNameList);
}

export function* saveMappedCompanies(action) {
    let requestURL = `${CORE_API}/ratingservices/saveMappedCompanies`;
    try {
        const result = yield call(request, requestURL, { data: action.data, method: 'POST', headers: HTTP_HEADERS });
        result.requestBody = action.data;
        yield put(RatingCompanyMapActions.responseSaveMappedCompaniesSuccess(result));
    } catch (err) {
        yield put(RatingCompanyMapActions.responseSaveMappedCompaniesFailure(err.response))
    }
}

export function* saveMappedCompaniesData() {
    yield takeLatest(RatingCompanyMapActions.REQUEST_FOR_SAVE_MAPPED_COMPANYNAMES, saveMappedCompanies);
}